export const PATHWAY_STEPS_QUERY_KEY = ['pathwaySteps'];
